import { ActionType } from 'typesafe-actions';

import * as TicketsActions from 'store/actions/tickets';
import { TicketsResponse, CompaniesResponse } from 'store/types/tickets';
import { call, put, takeEvery } from 'redux-saga/effects';
import { rejectPromiseAction, resolvePromiseAction } from 'redux-saga-promise-actions';
import Endpoints from 'endpoints';
import GipsyyGDSApi from 'apis/GipsyGDS';
import GipsyyGDSApiPure from 'apis/GipsyGDSPure';

function* getAllTickets(action: ActionType<typeof TicketsActions.getAllTickets.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: TicketsResponse[] } = yield GipsyyGDSApi.get(Endpoints.getAllTickets(), {
      params: action?.payload,
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield put(TicketsActions.getAllTickets.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
    yield response.data;
  } catch (error) {
    console.log('error');
    yield put(TicketsActions.getAllTickets.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* getDetailsTickets(action: ActionType<typeof TicketsActions.getDetailsTicket.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: TicketsResponse[] } = yield GipsyyGDSApi.get(Endpoints.getDetailsTickets(), {
      params: action?.payload,
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield put(TicketsActions.getAllTickets.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
    yield response.data;
  } catch (error) {
    console.log(error);
    yield put(TicketsActions.getAllTickets.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* getCompanies(action: ActionType<typeof TicketsActions.getCompanies.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: { data: CompaniesResponse[] } } = yield GipsyyGDSApi.get(Endpoints.getCompanies(), {
      params: action?.payload,
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield put(TicketsActions.getCompanies.success(response.data.data));
    yield call(resolvePromiseAction, action, response.data.data);
    yield response.data.data;
  } catch (error) {
    console.log('error');
    yield put(TicketsActions.getAllTickets.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

export const watchTickets = [
  takeEvery(TicketsActions.getAllTickets.request, getAllTickets),
  takeEvery(TicketsActions.getCompanies.request, getCompanies),
  takeEvery(TicketsActions.getDetailsTicket.request, getDetailsTickets),
];
